<section id="contributorsSectionAboutPage"
         class="mb-8 lg:mb-16 flex justify-center bg-white flex-col items-center gap-24 max-md:p-2">
  <div class="col-span-12 p-8 gap-8 bg-[#1f2024] rounded-xl flex flex-wrap justify-around items-center
              [&>div>div]:font-tektur [&>div]:max-md:w-full w-full max-w-[1330px]">
    <div>
      <div class="text-[#8895a4] text-sm font-medium uppercase tracking-wide" i18n>
        since
      </div>
      <div class="text-[#dde1e6] text-6xl font-bold leading-[78.07px] tracking-widest">
        2022
      </div>
    </div>
    <div>
      <div class="text-[#8895a4] text-sm font-medium uppercase tracking-wide" i18n>
        volonteers
      </div>
      <div class="text-[#dde1e6] text-6xl font-bold leading-[78.07px] tracking-widest">
        250+
      </div>
    </div>
    <div>
      <div class="text-[#8895a4] text-sm font-medium uppercase tracking-wide" i18n>
        countries
      </div>
      <div
        class="text-[#dde1e6] text-6xl font-bold leading-[78.07px] tracking-widest">
        30+
      </div>
    </div>
    <div>
      <div class="text-[#8895a4] text-sm font-medium uppercase tracking-wide" i18n>
        cars delivered
      </div>
      <div class="text-[#dde1e6] text-6xl font-bold leading-[78.07px] tracking-widest">
        {{ metric()?.cars }}
      </div>
    </div>
    <div>
      <div class="text-[#8895a4] text-sm font-medium uppercase tracking-wide" i18n>
        WORTH OF TRUCKS
      </div>
      <div class="text-[#dde1e6] text-6xl font-bold leading-[78.07px] tracking-widest">

        @if (metric()?.money; as money) {
          {{ money | currencyShorten: '€' }}
        }
      </div>
    </div>
  </div>
  <div class="flex max-w-[1330px] w-full">
    @if (membersData) {
      <div class="flex flex-wrap w-full cursor-pointer">
        @for (member of membersData; track member) {
          <div class="w-1/4 relative group overflow-hidden max-md:w-full h-[300px]">
            <img class="flex w-full h-full object-cover" [src]="member.image" alt="Image">
            <div
              class="absolute inset-x-0 bottom-0 flex items-center justify-center bg-black bg-opacity-50 h-2/3 transform
                     translate-y-full opacity-100 transition-transform duration-500 ease-in-out group-hover:translate-y-0
                     group-hover:opacity-100"
            >
              <div class="flex flex-wrap gap-3 font-tektur px-6 relative">
                <div class="flex w-full justify-between">
                  <p class="text-white text-2xl">{{ member.name }}</p>
                  <img class="w-[24px] h-auto" [src]="member.flag" alt="flag">
                </div>
                <span class="text-[#dde1e6] text-base max-md:text-xl">{{ member.description }}</span>
              </div>
            </div>
            <div class="absolute top-[calc(100%-60px)] left-2 py-3 shadow-sm w-[50px] transition-all duration-500
                        group-hover:top-[calc(100%-90px-2/3*100%)] bg-[#2E2F29] rounded-md text-white"
            >
              <a [href]="member.link" target="_blank" class="text-2xl flex items-center justify-center">
                <ng-icon [name]="member.icon"/>
              </a>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
